export const ApiUrls = {
  login: 'portal/login',
  payResponse: 'plugin/pay-response',
  orderDetails: 'plugin/getOrderDetailsByCode',
}
